import script from "./VotesBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./VotesBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./VotesBrowser.vue?vue&type=style&index=0&id=7d97938b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d97938b"]])

export default __exports__